(function () {
  var root = document.querySelector('.jelly-home');
  if (!root) return;

  /* ---------- HERO title letter reveal + parallax ---------- */
  var heroTitle = root.querySelector('[data-hero-title]');
  if (heroTitle) {
    var text = heroTitle.textContent;
    heroTitle.innerHTML = text
      .split('')
      .map(function (ch, i) {
        var content = ch === ' ' ? '&nbsp;' : ch;
        return '<span style="display:inline-block;opacity:0;filter:blur(6px);transform:translateY(14px);animation:jellyMaterialize 0.7s ease forwards;animation-delay:' + (0.3 + i * 0.02) + 's">' + content + '</span>';
      })
      .join('');
    var styleTag = document.createElement('style');
    styleTag.textContent = '@keyframes jellyMaterialize{to{opacity:1;filter:blur(0);transform:translateY(0);}}';
    document.head.appendChild(styleTag);
  }

  var hero = root.querySelector('[data-home-hero]');
  var heroBag = root.querySelector('[data-hero-bag]');
  if (hero && heroBag) {
    hero.addEventListener('mousemove', function (e) {
      var x = (e.clientX / window.innerWidth - 0.5) * 24;
      var y = (e.clientY / window.innerHeight - 0.5) * 14;
      heroBag.style.transform = 'translate(' + x + 'px, ' + y + 'px) rotate(' + x * 0.15 + 'deg)';
    });
    hero.addEventListener('mouseleave', function () {
      heroBag.style.transform = 'translate(0,0) rotate(0)';
    });
  }

  /* ---------- Flow color carousel: single centered card, bg follows the active bag ---------- */
  function pastel(hex) {
    var v = hex.replace('#', '');
    var r = parseInt(v.substr(0, 2), 16), g = parseInt(v.substr(2, 2), 16), b = parseInt(v.substr(4, 2), 16);
    var mix = function (c) { return Math.round(c + (255 - c) * 0.62); };
    return '#' + [mix(r), mix(g), mix(b)].map(function (c) { return c.toString(16).padStart(2, '0'); }).join('');
  }
  var flow = root.querySelector('[data-flow-color]');
  if (flow) {
    var track = flow.querySelector('[data-flow-track]');
    var cards = Array.prototype.slice.call(track.querySelectorAll('.flow-color__card'));
    var prevBtn = flow.querySelector('[data-flow-prev]');
    var nextBtn = flow.querySelector('[data-flow-next]');
    var counterEl = flow.querySelector('[data-flow-current]');
    var dotsWrap = flow.querySelector('[data-flow-dots]');
    var activeIndex = 0, rafId = null;

    dotsWrap.innerHTML = cards.map(function (_, i) { return '<button type="button" class="dot' + (i === 0 ? ' is-active' : '') + '" data-flow-dot="' + i + '" aria-label="Aller au sac ' + (i + 1) + '"></button>'; }).join('');
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.dot'));

    function applyActive(index) {
      if (!cards[index]) return;
      cards.forEach(function (c) { c.classList.remove('is-active'); });
      cards[index].classList.add('is-active');
      activeIndex = index;
      var bg = pastel(cards[index].dataset.bg || '#F5F2EA');
      flow.style.setProperty('--flow-bg', bg);
      flow.style.setProperty('--flow-text', '#2b2b2b');
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === cards.length - 1;
      if (counterEl) counterEl.textContent = index + 1;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    function findActiveCard() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var minDist = Infinity, closest = 0;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        if (r.right < 0 || r.left > window.innerWidth) return;
        var dist = Math.abs(center - (r.left + r.width / 2));
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      applyActive(closest);
    }

    function scrollToCard(index) {
      if (index < 0 || index >= cards.length) return;
      var card = cards[index];
      var pos = card.offsetLeft - track.offsetWidth / 2 + card.offsetWidth / 2;
      track.scrollTo({ left: pos, behavior: 'smooth' });
    }

    track.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () { findActiveCard(); rafId = null; });
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToCard(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToCard(activeIndex + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { scrollToCard(i); }); });

    applyActive(0);
    window.setTimeout(function () { scrollToCard(0); }, 60);
  }

  /* ---------- Community wall: real customer photos, some slots left empty for future videos ---------- */
  var wall = root.querySelector('[data-wall]');
  if (wall) {
    var heights = [200, 260, 180, 230, 280, 190, 240, 210, 270, 185, 220, 250];
    var wcolors = ['#F0A8B8', '#A7CBD4', '#D2C4E0', '#9CC9AE', '#F5C6D6', '#BFDCE8', '#F1E4A8', '#E890A6'];
    var names = ['@sarah', '@ines', '@camille', '@hannah', '@chloe', '@lisa', '@emma', '@layla', '@selma', '@mila', '@jisoo', '@lena'];
    var photos = [];
    try { photos = JSON.parse(wall.dataset.wallPhotos || '[]'); } catch (e) { photos = []; }
    var videos = [];
    try { videos = JSON.parse(wall.dataset.wallVideos || '[]'); } catch (e) { videos = []; }
    var emptySlots = [2, 4, 7, 9, 11];
    var videoSlots = emptySlots.slice(0, videos.length);
    var photoIndex = 0;
    var videoIndex = 0;
    wall.innerHTML = heights
      .map(function (h, i) {
        var color = wcolors[i % wcolors.length];
        var isVideo = videoSlots.indexOf(i) !== -1;
        var isEmpty = emptySlots.indexOf(i) !== -1 && !isVideo;
        if (isVideo) {
          var video = videos[videoIndex];
          videoIndex++;
          return (
            '<div class="w-item w-item--video"><div style="height:' + h + 'px;"><video src="' + video + '" muted loop playsinline autoplay preload="auto"></video></div></div>'
          );
        }
        if (isEmpty) {
          return '<div class="w-item w-item--empty"><div style="height:' + h + 'px; background: linear-gradient(160deg, ' + color + '33, ' + color + '15)"><span class="w-empty-icon">&#127909;</span></div></div>';
        }
        var photo = photos[photoIndex];
        photoIndex++;
        if (photo) {
          return (
            '<div class="w-item"><div style="height:' + h + 'px;"><img src="' + photo + '" alt="Cliente portant son sac Jelly Firkin" loading="lazy"></div>' +
            '<div class="w-tag">' + names[i % names.length] + '</div></div>'
          );
        }
        return (
          '<div class="w-item"><div style="height:' + h + 'px; background: linear-gradient(160deg, ' + color + '55, ' + color + '22)"><span></span></div>' +
          '<div class="w-tag">' + names[i % names.length] + '</div></div>'
        );
      })
      .join('');

    wall.querySelectorAll('.w-item--video video').forEach(function (video) {
      video.play().catch(function () {});
    });
  }

  /* ---------- Charms teaser orbit ---------- */
  var ctPreview = root.querySelector('[data-charms-orbit]');
  if (ctPreview) {
    var charmPhotos = ctPreview.dataset.charmPhotos ? JSON.parse(ctPreview.dataset.charmPhotos) : [];
    charmPhotos.forEach(function (c) {
      var el = document.createElement('div');
      el.className = 'float-charm';
      el.style.left = '50%';
      el.style.top = '50%';
      var img = document.createElement('img');
      img.src = c.src;
      img.alt = c.alt || '';
      el.appendChild(img);
      ctPreview.appendChild(el);
    });
    var t = 0;
    var radius = 105;
    function animateOrbit() {
      var items = ctPreview.querySelectorAll('.float-charm');
      items.forEach(function (el, i) {
        var angle = (t + (i * 360) / items.length) * (Math.PI / 180);
        var x = Math.cos(angle) * radius, y = Math.sin(angle) * (radius * 0.55);
        el.style.transform = 'translate(' + (x - 20) + 'px, ' + (y - 20) + 'px)';
      });
      t += 0.35;
      requestAnimationFrame(animateOrbit);
    }
    animateOrbit();
  }
})();
